import {theme} from '../theme/theme';

export const getNumberOfItems = (currentBreakpoint: string | null): number => {
  if (currentBreakpoint?.toString() === theme.breakpoints[0]) return 4;
  if (currentBreakpoint?.toString() === theme.breakpoints[1]) return 6;
  if (currentBreakpoint?.toString() === theme.breakpoints[2]) return 8;
  return 12;
};
